import React, { useState,useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SlCalender } from "react-icons/sl";
import "./webstory.css"

const UpdatedDateRangeFilter = (props) => {
  const [error, setError] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [created_start, created_end] = props.dateRange || [];
  const datePickerRef = useRef(null);

  const handleBlur = () => {
    setIsFocused(false);
    if (created_start && !created_end) {
      setError("Please select both a start date and an end date.");
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleDateChange = (update) => {
    props.setDateRange(update);
    if ((update && update[0] && update[1]) || (!update || (!update[0] && !update[1]))) {
      setError('');
    }
  };

  // to open the calendar on click on calender icon
  const handleIconClick = () => {
    if (datePickerRef.current) {
      setIsFocused(true);
      datePickerRef.current.setFocus();
    }
  };

  const isFilled = created_start && created_end;
  const showActiveClass = isFocused || isFilled;

  return (
    <div className="date-range-filter col-md-9">
      <div className="date-range-filter-container">
        <SlCalender
          className={`date-range-filter-calender ${showActiveClass ? "calendar-icon-active" : ""}`}
          onClick={handleIconClick}
        />
        <DatePicker
          ref={datePickerRef} //to open calender while click on icon
          selectsRange
          startDate={created_start}
          endDate={created_end}
          onChange={handleDateChange}
          isClearable
          maxDate={new Date()}
          monthsShown={2}
          className="form-control2"
          placeholderText="YYYY/MM/DD - YYYY/MM/DD"
          onFocus={handleFocus}
          onBlur={handleBlur}
          dateFormat="yyyy/MM/dd"
          showYearDropdown
          yearDropdownItemNumber={200}
          scrollableYearDropdown
        />
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default UpdatedDateRangeFilter;
